import { CreditCreateInput, CreditDto, ExtendCreditInput } from '@mkp/shared/models';
import { ErrorState } from '@mkp/shared/util-state';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const creditApiActions = createActionGroup({
  source: 'Credit/API',
  events: {
    'Add Credit': props<{ credit: CreditCreateInput }>(),
    'Add Credit Succeed': emptyProps(),
    'Add Credit Failed': props<{ error: ErrorState }>(),
    'Load Credits': emptyProps(),
    'Load Credits Succeed': props<{ credits: CreditDto[] }>(),
    'Load Credits Failed': props<{ error: ErrorState }>(),
    // 'Available Credits Loaded Success': props<{ availableCredits: AvailableCredits[] }>(),
    // 'Available Credits Loaded Failed': props<{ error: ErrorState }>(),
    'Load Credit Total Count': emptyProps(),
    'Load Credit Total Count Succeed': props<{ totalCount: number }>(),
    'Load Credit Total Count Failed': props<{ error: ErrorState }>(),
    'Load Free Credit Usage This Year Succeed': props<{ used: boolean }>(),
    'Load Free Credit Usage This Year Failed': props<{ error: ErrorState }>(),
    'Extend Credit': props<{ creditId: string; payload: ExtendCreditInput }>(),
    'Extend Credit Succeed': emptyProps(),
    'Extend Credit Failed': props<{ error: ErrorState }>(),
  },
});
